import Inputmask from "inputmask";

export const addMask = () => {
    try {
        let phones = document.querySelectorAll('input[type="tel"]');
        let emails = document.querySelectorAll('.field__email');

        phones.forEach(phone => {
            const inputMaskPhone = new Inputmask('+7 (999) 999-99-99');
            inputMaskPhone?.mask(phone);
        })

        emails.forEach(email => {
            const inputMaskEmail = new Inputmask('email');
            inputMaskEmail?.mask(email);
        })
    } catch (e) {

    }
}
